import React ,{useState} from 'react'
import {Descriptions, Flex, Image, Modal, Space,} from 'antd';
import AppEdit from './AppEdit';
function AppCheck(props) {
    const [open, setOpen] = useState(false);
    const Ok = () => {setOpen(false);};
    const Cancel = () => {setOpen(false);};
    const items = [
        {
            key:'1',
            label:'品牌平台',
            children:props.brand,
        },
        {
            key:'2',
            label:'产品名称',
            children:props.appName,
        },
        {
            key:'3',
            label:'产品图标',
            children:<Image src={`/api/assets/images/application/${props.src}`} width={40}/>,
        },
        {
            key:'4',
            label:'收费类型',
            children:props.payType==='1'?<>免费</>:<>收费</>,
        },
        {
            key:'5',
            label:'产品编号',
            children:props.appId,
            span:2,
        },        
        {
            key:'7',
            label:'用户需求',
            children:<div dangerouslySetInnerHTML={{__html:props.esv_remark}}></div>,
            span:3,
        },
        {
            key:'8',
            label:'收费方式',
            children:<div dangerouslySetInnerHTML={{__html:props.esv_content}}></div>,
            span:3,
        },
        {
            key:'6',
            label:'操作',
            children:<AppEdit  esv_id={props.appId} />,
        },

    ]
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space style={{fontSize:"18px"}}>
                    《
                    <span>{props.brand}</span>
                    <span>-</span>
                    <span>{props.appName}</span>
                    <span>-</span>
                    <span>No.{props.appId}</span>》
                </Space>
            </a>
            <Modal 
                title={props.esv_name} 
                open={open} 
                onOk={Ok} 
                onCancel={Cancel} 
                okText='关闭' 
                footer={null}
                width={1200}
            >
                <div style={{
                    border:'2px solid #eee',
                    margin:"10px",
                    padding:'10px'
                    }}>
                    <Flex 
                        justify='center'
                        style={{
                            padding:"20px 0"
                        }}
                    >
                        <h1>产品说明书</h1>
                    </Flex>
                    <Descriptions
                        items={items}
                        bordered
                    />
                </div>        
            </Modal>
        </>
    )
}

export default AppCheck